import Auth from '@aetosky/auth';
import GeocodeBaseApi from './GeocodeBaseApi'
import axios from 'axios'

class GeocodeApi extends GeocodeBaseApi {
  /** Overide base methods **/

  /**
   * Normal http request
   *
   * @param {string} method http method
   * @param {string} url http url
   * @param {Object} data params for get or body data for post, put, patch
   * @param {Object} config axios config object. See https://github.com/mzabriskie/axios
   */
  submit(method, url, data, config = {}) {
    return super.submit(method, url, data, config)
  }

  /**
   * Submit http request with Authorization header
   *
   * @param {string} method http method
   * @param {string} url http url
   * @param {Object} data params for get or body data for post, put, patch
   * @param {Object} config axios config object. See https://github.com/mzabriskie/axios
   */
  async authSubmit(method, url, data, config = {}) {
    const accesstoken = await Auth.getInstance().getToken()
    super.setAuthToken(accesstoken)
    return super.submit(method, url, data, config)
  }

  getCountries(payload = {}) {
    return this.authSubmit('get', `/countries`, payload)
  }

  getDetailCountry(gid_0) {
  }

  getStates(gid_0) {
    return this.authSubmit('get', `/adm_1?gid_0=${gid_0}`)
  }

  getDistricts(gid_0, gid_1) {
    return this.authSubmit('get', `/adm_2?gid_0=${gid_0}&gid_1=${gid_1}`)
  }

  getDistrictDetail(gid_2) {
    return this.authSubmit('get', `/adm_2/${gid_2}`)
  }

  getSubDistricts(gid_0, gid_1, gid_2) {
    return this.authSubmit('get', `/adm_3?gid_0=${gid_0}&gid_1=${gid_1}&gid_2=${gid_2}`)
  }

  getSubDistrictDetail(gid_3) {
    return this.authSubmit('get', `/adm_3/${gid_3}`)
  }

  getStateDetail(code) {
    return this.authSubmit('get', `/adm_1/${code}`)
  }

  getStateDetails(code) {
    return this.authSubmit('get', `/adm_1/${code}`)
  }

  getDetailLocation(code) {
    return this.authSubmit('get', `/adminitrative/autocomplete/${code}`)
  }

  searchLocation(query) {
    return this.authSubmit('get', `/autocomplete?q=${query}`)
  }

  mergeStates(form) {
    let params = ''
    if (form.gids && form.gids.length > 0) {
      params = form.gids.map(gid => `gids=${gid}`).join('&')
      delete form.gids
    }
    return this.authSubmit('get', `/tools/adm_1/geometry?${params}`, form)
  }

  mergeDistricts(form) {
    let params = ''
    if (form.gids && form.gids.length > 0) {
      params = form.gids.map(gid => `gids=${gid}`).join('&')
      delete form.gids
    }
    return this.authSubmit('get', `/tools/adm_2/geometry?${params}`, form)
  }
}

export default new GeocodeApi()



// WEBPACK FOOTER //
// ./src/api/GeocodeApi.js